import Script from 'next/script';

const AWF = () => {
    return <>
        <Script type="text/javascript" src="https://e92d315902d2.edge.sdk.awswaf.com/e92d315902d2/afcbbd2e03e0/challenge.js" strategy='beforeInteractive' />
        <Script type="text/javascript" src="https://e92d315902d2.edge.captcha-sdk.awswaf.com/e92d315902d2/jsapi.js" strategy='beforeInteractive' />
    </>;
}

export default AWF;